// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const IoniQ = {
  productCode: " IoniQ",
  productName: "IoniQ (Cell Revital)",
  ingredients: "Garcinia cambogia, Citrus aurantium",
  overview:"Ioniq is a nutritive; rehydrating beverage without artificial sweetener contains balanced electrolytes. ",
  assay:"Garcinia cambogia extract: 2 g; Bioflavanoids: 50 mg; Protein isolates: 4 g",
  coNutrients:"Secondary metabolites include amino acids, alkaloids, Saponins and flavonoids.",
  studies:"",
  benefits:" Diaet whole-food supplement helps inhibit glucosidase enzyme and lowers blood sugar, improves insulin production and suppress appetite with the help of 75% Gymnemic acid. Banaba extract helps with inhibitory effect on postprandial hyperglycemia. Salacia reticulata improves abnormal glucose tolerance, fatty degeneration of hepatocytes and anti-obesity effect. The vitamins and minerals present in DIAET help improve insulin sensitivity. Natural Cobalamin co-factors in Shiitake Vitamer Complex (B12-Corrinoids) improve the symptoms of peripheral neuropathy and provide an overall nutritional balance to diabetes condition.",
  functionalUse: {
    main: " 🥄︎ Powder",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForRegenerativeHealth/.png"
    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default IoniQ;
